/**
 * CanonicalClient context — carries the current canonical client_id
 * (Phase-2) alongside the legacy email while a practitioner works
 * inside `/clients/<email>?as=<cid>`.
 *
 * The clinical tabs (SoapNotesList, ExerciseProgramsPanel,
 * AssessmentsTab, HealthRecordTab, …) call ``useCanonicalClient()``
 * to know whether they should filter their lists / stamp their
 * writes with a canonical id. When there's no context (plain
 * `/clients/<email>` visit), it returns null and behaviour is
 * identical to before.
 *
 * Kept intentionally tiny — no state management, just a value
 * passthrough — so the migration to canonical-first routing is a
 * one-line prop drop from any tab.
 */
import { createContext, useContext } from "react";

export const CanonicalClientContext = createContext(null);

/**
 * @returns {{ clientId: string, fullName: string } | null}
 */
export function useCanonicalClient() {
  return useContext(CanonicalClientContext);
}

/**
 * Helper for adding the canonical id to axios params when present.
 * Usage: ``api.get(url, { params: withCanonicalId(canonical, { ... }) })``
 */
export function withCanonicalId(canonical, params) {
  const p = { ...(params || {}) };
  if (canonical?.clientId) p.canonical_client_id = canonical.clientId;
  return p;
}
